import { Routes, Route, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import SignIn from "./SignIn";
import TimekeepingMainComponent from "./HomePage";
import WebsiteHomePage from './pages/HomePage.jsx';
import DaySmartDashboard from './pages/DaySmartDashboard.jsx';
import CommunicationCenter from './pages/CommunicationCenter.jsx';
import LogoPage, { LogoSmallPage } from './pages/LogoPage.jsx';


const App = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      console.log("Auth state changed:", currentUser);
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  return (
      <Routes>
        <Route path="/signin" element={user ? <Navigate to="/timekeeping" /> : <SignIn />} />
        <Route path="/timekeeping" element={user ? <TimekeepingMainComponent /> : <Navigate to="/signin" />} />
        <Route path="/daysmart" element={user ? <DaySmartDashboard /> : <Navigate to="/signin" />} />
        <Route path="/communication-center" element={user ? <CommunicationCenter /> : <Navigate to="/signin" />} />
        <Route path="/logo" element={<LogoPage />} />
        <Route path="/logo-small" element={<LogoSmallPage />} />
        <Route path="*" element={<Navigate to={user ? "/timekeeping" : "/signin"} />} />
        <Route path="/zoomgroom" element={<WebsiteHomePage />} />
      </Routes>
  );
};

export default App;
